import PropTypes from 'prop-types';
import React from 'react';
export var ChartNoData = function ChartNoData(props) {
  var height = props.height,
      width = props.width,
      noDataText = props.noDataText;
  return React.createElement("g", null, React.createElement("text", {
    className: "NoGraphData",
    x: width / 2,
    y: height / 2,
    textAnchor: "middle"
  }, noDataText));
};
ChartNoData.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  noDataText: PropTypes.string.isRequired
};
export default ChartNoData;